import React, { useContext, useEffect } from "react";
import { MyProfileCollaborationsContainer } from "./MyProfileCollaborationsStyled";
import { FormattedMessage, useIntl } from 'react-intl';

import camera from './../../utils/images/camera.svg';
import avatar from './../../utils/images/avatar_fluincr.png';
import { getCollaborationsByCompanyIdAndStatus, getCollaborationsByInfluencerIdAndStatus, getContentCollaboration, getContentCollaboration2 } from "../../api/collaborationApi";
import { UserContext } from "../../context/userContext";
import { useState } from "react";
import ModalCarousel from "../ModalCarousel/ModalCarousel";
import ModalCarouselCollaborations from "../ModalCarouselCollaboration/ModalCarouselCollaboration";
import CollaborationCardPrivateProfile from "../CollaborationCardPrivateProfile/CollaborationCardPrivateProfile";

export default function MyProfileCollaborations() {

    const { userType, id, companyId } = useContext(UserContext);
    const [collaborations, setCollaborations] = useState([]);

    /* const [collaborationSelected, setCollaborationSelected] = useState();
    const [showCarousel, setShowCarousel] = useState(false);
    const [content, setContent] = useState([]);
 */
    useEffect(() => {

        if (userType === 'influencer' && id !== null) {
            //Debe ser status 5 es decir las colaboraciones terminadas
            getCollaborationsByInfluencerIdAndStatus({ influencerId: id, status: 5 }).then((response) => {
                setCollaborations(response)
            })
        } else {
            getCollaborationsByCompanyIdAndStatus({ companyId: companyId, status: 5 }).then((response) => {
                setCollaborations(response)
            })
        }
    }, [id, companyId])


    return (
        <MyProfileCollaborationsContainer>
            <h2 className="title"><FormattedMessage id="my_profile_subtitle_2" defaultMessage="Colaboraciones" /></h2>
            <div className="cardsContainer">

                {collaborations.map((collaboration) => {
                    return (
                        <CollaborationCardPrivateProfile collaboration={collaboration} profileUserType={userType} />
                    )
                })}
                {(collaborations.length < 1) && (<>
                    <div className="card" >
                        <img src={camera} alt="camera" />
                        <p><FormattedMessage id="my_profile_text_18" defaultMessage="Nuevas colaboraciones pronto" /></p>
                    </div>
                    <div className="card" >
                        <img src={camera} alt="camera" />
                        <p><FormattedMessage id="my_profile_text_18" defaultMessage="Nuevas colaboraciones pronto" /></p>
                    </div>
                    <div className="card" >
                        <img src={camera} alt="camera" />
                        <p><FormattedMessage id="my_profile_text_18" defaultMessage="Nuevas colaboraciones pronto" /></p>
                    </div>
                    <div className="card" >
                        <img src={camera} alt="camera" />
                        <p><FormattedMessage id="my_profile_text_18" defaultMessage="Nuevas colaboraciones pronto" /></p>
                    </div>
                </>)}

            </div>

        </MyProfileCollaborationsContainer>
    )
}